export const OrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type OrderDirection = (typeof OrderDirection)[keyof typeof OrderDirection];
